// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type EmptyResponse = any;

export const fetchAndEnforceApiResponseData = async <T>(
  promiseFn: () => Promise<ApiResponse<T>>,
): Promise<T | undefined> => {
  const { data, resultCode, messages } = await promiseFn();
  if (resultCode !== 0) {
    throw new Error((messages || []).join('\\n'));
  }
  return data;
};

export class ApiResponse<TModel extends EmptyResponse> {
  constructor(
    public data?: TModel,
    public messages: string[] = [],
    public resultCode: number = 0,
  ) {}
  public static success<TModel>(
    model: TModel,
    ...messages: string[]
  ): ApiResponse<TModel> {
    return new ApiResponse(model, messages, 0);
  }
}
